// ComponentResolver — převod a ověřování referencí IFC prvků (§9, §28, §29).
// Primární identifikátor je { modelId, globalId }. Runtime ID (expressID apod.)
// je čistě interní záležitost vieweru a přes adapter se ven nedostává.
export const RESOLUTION = Object.freeze({ RESOLVED: "resolved", MISSING: "missing", AMBIGUOUS: "ambiguous" });

export class ComponentResolver {
  constructor(adapter) { this.adapter = adapter; }

  // Ověří jeden ref proti aktuálně načteným modelům.
  resolveOne(ref) {
    if (!ref || !ref.globalId) return RESOLUTION.MISSING;
    if (ref.modelId) return this.adapter.hasComponent(ref.modelId, ref.globalId) ? RESOLUTION.RESOLVED : RESOLUTION.MISSING;
    // Bez modelId (starší BCF) — hledáme napříč modely; víc shod = ambiguous.
    const models = this.adapter.listModels();
    const hits = models.filter((m) => this.adapter.hasComponent(m.modelId, ref.globalId));
    if (hits.length === 0) return RESOLUTION.MISSING;
    if (hits.length > 1) return RESOLUTION.AMBIGUOUS;
    return RESOLUTION.RESOLVED;
  }

  // Vyhodnotí sadu referencí (§29): kolik resolved/missing/ambiguous.
  resolveMany(refs) {
    const out = { total: 0, resolved: [], missing: [], ambiguous: [] };
    for (const ref of refs || []) {
      out.total++;
      const r = this.resolveOne(ref);
      if (r === RESOLUTION.RESOLVED) out.resolved.push(ref);
      else if (r === RESOLUTION.AMBIGUOUS) out.ambiguous.push(ref);
      else out.missing.push(ref);
    }
    return out;
  }

  // Doplní modelId u referencí bez modelu (jednoznačné shody) — pro federaci.
  normalizeRefs(refs) {
    const models = this.adapter.listModels();
    return (refs || []).map((ref) => {
      if (ref.modelId) return ref;
      const hits = models.filter((m) => this.adapter.hasComponent(m.modelId, ref.globalId));
      return hits.length === 1 ? { ...ref, modelId: hits[0].modelId } : ref;
    });
  }
}
